import { gql } from '@apollo/client';

import { mediaListItemFragment } from '../fragments';

export default gql`
  query GetMediaItemBySubject($courseId: String!, $subjectId: String!) {
    mediaItems(courseId: $courseId, subjectId: $subjectId)
      @rest(
        type: "MediaItem"
        path: "courses/{args.courseId}/subjects/{args.subjectId}/videos"
      ) {
      ...MediaListItem
    }
  }
  ${mediaListItemFragment}
`;
